<div class="blog-area pt-50 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span class="sub-title" i18n>Explore Our Articles</span>
            <h2 i18n>Our Latest Publications</h2>
            <a routerLink="/articles" class="default-btn"><i class='bx bx-book-reader icon-arrow before'></i><span
                    class="label" i18n>Read All</span><i class="bx bx-book-reader icon-arrow after"></i></a>
        </div>

        <!-- carousel starts here -->

        <div class="blog-slides" [class.dark-blog-slides]="themeService.isDark()">
            <owl-carousel-o [options]="blogSlides">
                <ng-template carouselSlide *ngFor="let article of articles">
                    <div class="single-blog-post mb-30">
                        <div class="post-image">
                            <a routerLink="/articles/{{article.id}}" class="d-block">
                                <img src="{{imageUrl}}{{article.article_images[0]?.image_url}}" style="max-height:22rem" alt="image">
                            </a>
                            <div class="tag">
                                <a>{{article.type.type_name}}</a>
                            </div>
                        </div>
                        <div class="post-content">
                            <ul class="post-meta">
                                <li class="post-author">
                                    <span i18n>By</span>: <a class="d-inline-block">{{article.author}}</a>
                                </li>
                                <li><a i18n>{{article.published_date | date:'longDate'}}</a></li>
                            </ul>
                            <h3><a class="d-inline-block" >
                                {{article.title}}
                            </a></h3>
                            <a routerLink="/articles/{{article.id}}" class="read-more-btn" i18n>Read More <i
                                    class='bx bx-right-arrow-alt'></i></a>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>

        <!-- carousel ends here -->
    </div>
</div>